import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import Modal from 'react-bootstrap/Modal';
import authService from './api-authorization/AuthorizeService';

interface ShutdownPeriods {
    shutdownPeriodTypes: GenericList[];
    addShutdownPeriod: AddShutdownPeriod;
    shutdownPeriods: ShutdownPeriodList[];
    showConfirmModal: boolean;
    deletePeriodId: number;
    deletePeriodIndex: number;
    loading: boolean;
    errors: any;
}

interface AddShutdownPeriod {
    startDate: string;
    endDate: string;
    chargeId: number;
    subId: string;
}

interface ShutdownPeriodList {
    id: number;
    startDateFormatted: number;
    endDateFormatted: string;
    chargeType: string;
}

interface GenericList {
    id: number;
    name: string;
}

export class ShutdownPeriodData extends React.Component<RouteComponentProps<{}>, ShutdownPeriods> {
    constructor(props: any) {
        super(props);

        this.state = {
            shutdownPeriodTypes: [],
            addShutdownPeriod: {
                startDate: "",
                endDate: "",
                chargeId: -1,
                subId: ""
            },
            shutdownPeriods: [],
            showConfirmModal: false,
            deletePeriodId: 0,
            deletePeriodIndex: 0,
            loading: true,
            errors: {}
        }  
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=CreateEditAdminLists&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.getShutdownPeriods();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async getShutdownPeriods() {
        const token = await authService.getAccessToken();

        axios.get('api/Admin/GetShutdownPeriods', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ shutdownPeriods: res.data.shutdownPeriods, shutdownPeriodTypes: res.data.shutdownPeriodTypes, loading: false });
        })
    }

    handleAddChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change = this.state.addShutdownPeriod;
        if (e.target.name === "chargeId") {
            change[e.target.name] = e.target.value * 1;
        } else {
            change[e.target.name] = e.target.value;
        }
        change["errors"] = errors;
        this.setState(change);
    }

    validateAdd = () => {
        let formIsValid = true;
        let errors: any = {};

        let fields = this.state.addShutdownPeriod;
        if (!fields.startDate) {
            errors["startDate"] = "Start Date is Required";
            formIsValid = false;
        } else if (!DateHelpers.isValidDate(fields.startDate)) {
            errors["startDate"] = "Valid Start Date is Required";
            formIsValid = false;
        }

        if (!fields.endDate) {
            errors["endDate"] = "End Date is Required";
            formIsValid = false;
        } else if (!DateHelpers.isValidDate(fields.endDate)) {
            errors["endDate"] = "Valid End Date is Required";
            formIsValid = false;
        }

        if (fields.chargeId < 0) {
            errors["chargeId"] = "Charge Type is Required";
            formIsValid = false;
        }

        if (formIsValid) {
            //check if end date > start date
            //check to make sure install date is before or equal to offhire date
            if (!DateHelpers.compareDateGreater(fields.startDate, fields.endDate)) {
                errors["endDate"] = "End Date must be > Start Date, ";
                formIsValid = false;
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    submitAdd = () => {
        if (this.validateAdd()) {
            this.saveShutdownPeriods();
        }
    }

    async saveShutdownPeriods() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var shutdownPeriod = this.state.addShutdownPeriod;
        shutdownPeriod.subId = user.sub;

        axios.post('api/Admin/SaveShutdownPeriod', shutdownPeriod, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Shutdown Period Saved");
            //then need to clear holiday so can save a new one
            var period: AddShutdownPeriod = {
                startDate: "",
                endDate: "",
                chargeId: -1,
                subId: ""
            };

            this.setState({ addShutdownPeriod: period });
            this.getShutdownPeriods();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    deleteItem = (e: any, deletePeriodId: number, deletePeriodIndex: number) => {
        e.preventDefault();
        this.setState({ deletePeriodId: deletePeriodId, deletePeriodIndex: deletePeriodIndex, showConfirmModal: true });
    }

    hideConfirmModal = () => {
        this.setState({ deletePeriodId: 0, deletePeriodIndex: 0, showConfirmModal: false });
    }

    saveConfirmModal = () => {
        this.saveDeleteShutdownPeriod();
    }

    async saveDeleteShutdownPeriod() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var shutdownPeriod = {
            shutdownPeriodId: this.state.deletePeriodId,
            subId: user.sub
        };

        axios.post('api/Admin/DeleteShutdownPeriod', shutdownPeriod, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Shutdown Period Deleted Successfully");
            var shutdownPeriods = this.state.shutdownPeriods;
            shutdownPeriods.splice(this.state.deletePeriodIndex, 1);

            this.setState({ shutdownPeriods: shutdownPeriods, deletePeriodId: 0, deletePeriodIndex: 0, showConfirmModal: false });
        })
        .catch(error => {
            //var errors = error.response.data as any[];
            //errors.map(function (error: any) {
            //    toast.error(error);
            //});
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Shutdown Periods</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let addShutdownPeriod = this.state.addShutdownPeriod;
        let shutdownPeriods = this.state.shutdownPeriods;
        let shutdownPeriodTypes = this.state.shutdownPeriodTypes;

        return (
            <div>
                <div className="static-modal">
                    <Modal size="sm" show={this.state.showConfirmModal} onHide={this.hideConfirmModal}>
                        <Modal.Header className="modal__header--colour">
                            <Modal.Title>Delete Shutdown Period</Modal.Title>
                            <button type="button" className="close" onClick={this.hideConfirmModal}>&times;</button>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <p>Are you sure you want to delete this shutdown period?</p>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button className="popup-button--no" onClick={this.hideConfirmModal}>No</button>
                            <button className="popup-button--yes" onClick={this.saveConfirmModal}>Yes</button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div>
                    <div>
                        <span>Enter dates for when the office shut downs over the Christmas period.<br /></span>
                        <span>Customers: in the Customer Admin screen, on the Customer Rules tab select which hire period customers will not be charged equipment hire for. See below for rules/days<br /><br /></span>

                        <span>Charge Type: No Charge Part Shutdown<br /></span>
                        <span>The part shutdown period is generally Christmas day to New Years day. This means that any customers (most of them) will not be charged equipment hire during this period <br /><br /></span>
                        <span>Charge Type: No Charge Full Shutdown<br /></span>
                        <span>The full shutdown period is generally when the office is shut down.  Generally a few days before christmas and after new years day.  Only a few customers do not get charged equipment hire for this period.<br /><br /></span>
                    </div>
                    <label className="input-group" htmlFor="startDate">
                        <span className="label">Start Date</span>
                        <input type='date' id="startDate" name="startDate" className='input' value={addShutdownPeriod.startDate} onChange={(e) => this.handleAddChange(e)}></input>
                    </label>
                    <span className="label errors textalignleft marginLeft10">{this.state.errors["startDate"]}</span>

                    <label className="input-group" htmlFor="endDate">
                        <span className="label">End Date</span>
                        <input type='date' id="endDate" name="endDate" className='input' value={addShutdownPeriod.endDate} onChange={(e) => this.handleAddChange(e)}></input>
                    </label>
                    <span className="label errors textalignleft marginLeft10">{this.state.errors["endDate"]}</span>

                    <label className="input-group" htmlFor="chargeId">
                        <span className="label">Charge Type</span>
                        <select className="select" id="chargeId" name="chargeId" value={addShutdownPeriod.chargeId} onChange={(e) => this.handleAddChange(e)}>
                            <option hidden defaultValue="-1"></option>
                            {shutdownPeriodTypes.map(type =>
                                <option key={type.id} value={type.id}>{type.name}</option>
                            )};
                        </select>
                    </label>
                    <span className="label errors">{this.state.errors["chargeId"]}</span>

                    <button className="defaultbutton defaultbutton__small form-margin" onClick={this.submitAdd} type="button">Add</button>
                </div>
                <div>
                    <hr></hr>
                </div>
                <div className="marginBottom20">
                    <div className="job__noteGridSize overflowAuto">
                        <table className="table tableColours">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Charge Type</th>
                                    <th></th>
                                </tr>
                            </thead>
                            {shutdownPeriods.map((period, index) =>
                                <tbody key={period.id}>
                                    <tr>
                                        <td className="hidden">{period.id}</td>
                                        <td>{period.startDateFormatted}</td>
                                        <td>{period.endDateFormatted}</td>
                                        <td>{period.chargeType}</td>
                                        <td>
                                            <div className="delete--tablecell">
                                                <a className="makeitred" href="#" onClick={(e) => this.deleteItem(e, period.id, index)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        );

    }

};